import TitleBar2 from './titleBar2';
export default TitleBar2;
